var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "policy-config-container" },
    [
      _c("div", { staticClass: "stats-bar" }, [
        _c("div", { staticClass: "stat-item" }, [
          _c("i", { staticClass: "el-icon-s-data" }),
          _c("div", { staticClass: "stat-content" }, [
            _c("div", { staticClass: "stat-label" }, [_vm._v("规则总数")]),
            _c("div", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.overview.totalRules || 0)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-item success" }, [
          _c("i", { staticClass: "el-icon-circle-check" }),
          _c("div", { staticClass: "stat-content" }, [
            _c("div", { staticClass: "stat-label" }, [_vm._v("已启用")]),
            _c("div", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.overview.enabledRules || 0)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-item warning" }, [
          _c("i", { staticClass: "el-icon-warning-outline" }),
          _c("div", { staticClass: "stat-content" }, [
            _c("div", { staticClass: "stat-label" }, [_vm._v("已禁用")]),
            _c("div", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.overview.disabledRules || 0)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-item info" }, [
          _c("i", { staticClass: "el-icon-time" }),
          _c("div", { staticClass: "stat-content" }, [
            _c("div", { staticClass: "stat-label" }, [_vm._v("最后发布")]),
            _c("div", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.overview.lastPublishTime || "-")),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "publish-btn" },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  icon: "el-icon-upload",
                  loading: _vm.publishLoading,
                },
                on: { click: _vm.handlePublish },
              },
              [_vm._v(" 发布配置 ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        { staticClass: "threshold-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-s-data" }),
              _c("span", [_vm._v("评分阈值配置")]),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary", plain: "" },
                  on: { click: _vm.handleEditThreshold },
                },
                [_vm._v("编辑")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "threshold-list" },
            _vm._l(_vm.thresholdList, function (item, index) {
              return item
                ? _c(
                    "div",
                    {
                      key: item ? item.id || index : index,
                      staticClass: "threshold-item",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "level-badge",
                          style: { background: item.color },
                        },
                        [_vm._v(_vm._s(item.levelName))]
                      ),
                      _c("div", { staticClass: "score-range" }, [
                        _vm._v(
                          "分值区间: " +
                            _vm._s(item.minScore) +
                            " - " +
                            _vm._s(item.maxScore)
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "action-tag" },
                        [
                          _c("el-tag", { attrs: { size: "small" } }, [
                            _vm._v(_vm._s(item.action)),
                          ]),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e()
            }),
            0
          ),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "rules-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-s-operation" }),
              _c("span", [_vm._v("风控规则配置")]),
            ]
          ),
          _c(
            "el-table",
            { attrs: { data: _vm.ruleList, border: "", stripe: "" } },
            [
              _c("el-table-column", {
                attrs: { prop: "ruleName", label: "规则名称", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "ruleDesc", label: "描述", "min-width": "200" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "category",
                  label: "分类",
                  width: "120",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "riskScore",
                  label: "风险分值",
                  width: "120",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getScoreTagType(scope.row.riskScore),
                              size: "small",
                            },
                          },
                          [_vm._v(" " + _vm._s(scope.row.riskScore) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "状态",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: { "active-value": 1, "inactive-value": 0 },
                          on: {
                            change: function ($event) {
                              return _vm.handleToggleStatus(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "120",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditRule(scope.row)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "el-icon-edit" }),
                            _vm._v(" 编辑 "),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑规则",
            visible: _vm.editRuleVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editRuleVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.editRuleForm, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "规则名称" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.editRuleForm.ruleName,
                      callback: function ($$v) {
                        _vm.$set(_vm.editRuleForm, "ruleName", $$v)
                      },
                      expression: "editRuleForm.ruleName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "风险分值" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, max: 100 },
                    model: {
                      value: _vm.editRuleForm.riskScore,
                      callback: function ($$v) {
                        _vm.$set(_vm.editRuleForm, "riskScore", $$v)
                      },
                      expression: "editRuleForm.riskScore",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "规则参数" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "JSON格式",
                    },
                    model: {
                      value: _vm.editRuleForm.configParams,
                      callback: function ($$v) {
                        _vm.$set(_vm.editRuleForm, "configParams", $$v)
                      },
                      expression: "editRuleForm.configParams",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editRuleVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitEditRule },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑评分阈值",
            visible: _vm.editThresholdVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editThresholdVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.editThresholdList, border: "" } },
            [
              _c("el-table-column", {
                attrs: { prop: "levelName", label: "风险等级", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { label: "最小分值", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input-number", {
                          attrs: {
                            min: 0,
                            size: "small",
                            disabled: scope.row.id !== "low",
                          },
                          model: {
                            value: scope.row.minScore,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "minScore", $$v)
                            },
                            expression: "scope.row.minScore",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "最大分值", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input-number", {
                          attrs: { min: 0, max: 100, size: "small" },
                          model: {
                            value: scope.row.maxScore,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "maxScore", $$v)
                            },
                            expression: "scope.row.maxScore",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "处理动作", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: { size: "small" },
                            model: {
                              value: scope.row.action,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "action", $$v)
                              },
                              expression: "scope.row.action",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "PASS（通过）", value: "PASS" },
                            }),
                            _c("el-option", {
                              attrs: { label: "LOG（记录）", value: "LOG" },
                            }),
                            _c("el-option", {
                              attrs: { label: "3DS（强认证）", value: "3DS" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editThresholdVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitEditThreshold },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }